// Define action types
export const SET_RECORD_PAYMENT_RESPONSE = 'SET_RECORD_PAYMENT_RESPONSE';

// Define action creators
export const setRecordPaymentResponse = (response) => ({
  type: SET_RECORD_PAYMENT_RESPONSE,
  payload: response,
});
